
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { OrcadoRealizado } from 'src/app/core/orcado-realizado.model';
import { Observable } from 'rxjs/Observable';
import { BuilderHttp } from '../seguranca/builder-http';


@Injectable()
export class CoreService {

  coreUrlAPI = `${environment.apiUrl}/api/core`;

  constructor(
    private httpBuilder: BuilderHttp
  ) { }


  getOrcadoRealizado(): Observable<OrcadoRealizado[]> {
    return this.httpBuilder.get<OrcadoRealizado[]>(`${this.coreUrlAPI}`);
  }

}
